import { ErrorMessage, Field, Label } from "@/components/catalyst/fieldset";
import { UseFormRegisterReturn, FieldError } from "react-hook-form";
import { Input } from "@/components/catalyst/input";

type EmailFieldProps = {
  register: UseFormRegisterReturn<"email">;
  error?: FieldError;
  disabled?: boolean;
  invalid?: boolean;
  testId?: string;
};

export function EmailField({
  register,
  error,
  disabled = false,
  invalid,
  testId,
}: EmailFieldProps) {
  return (
    <Field>
      <Label>Email</Label>
      <Input
        {...register}
        type="email"
        disabled={disabled}
        invalid={invalid ?? !!error}
        data-testid={testId}
      />
      {error?.message && <ErrorMessage>{error.message}</ErrorMessage>}
    </Field>
  );
}
